<template>
  <div>
    <g-chart type="BarChart" :data="stats.chart" :options="options" :events="events" @ready="onReady" />
  </div>
</template>

<script>
import { GChart } from 'vue-google-charts'

export default {
  props: {
    stats: Object,
    onSelect: Function
  },
  components: {
    GChart
  },
  watch: {
    stats: {
      deep: true,
      handler () {
        this.options.chartArea.height = this.stats.chart.length * 20
        this.options.height = this.stats.chart.length * 20 + 80
      }
    }
  },
  data () {
    return {
      chart: null,
      // data: [
      //   ['Mata Pelajaran', 'Guru PNS S1', 'Guru PNS Non-S1', 'Guru Non-PNS S1', 'Guru Non-PNS Non-S1', 'Target'],
      //   ['Guru Kelas', 100, 83, 22, 12, 240],
      //   ['Keterampilan', 117, 92, 34, 11, 300],
      //   ['Bahasa Daerah', 66, 54, 43, 22, 200],
      //   ['Potensi Daerah', 103, 76, 56, 21, 300],
      //   ['PJOK', 103, 76, 54, 32, 280],
      //   ['Seni & Budaya', 103, 95, 32, 8, 250]
      // ],
      options: {
        chart: {
          title: 'Kebutuhan Guru',
          subtitle: ''
        },
        legend: { position: 'top', maxLines: 3, textStyle: { fontSize: '10' } },
        seriesType: 'bars',
        isStacked: true,
        series: {
          0: { color: '#75c84e' },
          1: { color: '#6b87de' },
          2: { color: '#db6054' },
          3: { color: '#f7b758' },
          4: { color: '#0572fb', type: 'scatter' }
        },
        bar: { groupWidth: '80%' },
        vAxis: { textStyle: { fontSize: '10' } },
        chartArea: { left: 130, top: 50, width: '100%', height: this.stats.chart.length * 25, right: 4 },
        height: this.stats.chart.length * 25 + 80,
        backgroundColor: '#ffffff'
      },
      events: {
        select: this.handleSelect
      }
    }
  },
  mounted () {
  },
  methods: {
    onReady (chart, google) {
      this.chart = chart
    },
    handleSelect () {
      let selected = this.chart.getSelection()
      this.onSelect(selected[0].row)
    }
  }
}
</script>
